export default __webpack_public_path__ + "static/media/flask.84ed5878.png";